import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";

export default function TechniquesEmptyState({ onReset }) {
  return (
    <div className="rounded-[24px] border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white text-slate-400 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <FaSearch className="text-2xl" />
      </div>

      <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
        Aucune technique trouvée
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
        Aucun résultat ne correspond aux filtres sélectionnés. Essayez de
        modifier la recherche, la ceinture, la famille ou la fiche UV2.
      </p>

      <button
        type="button"
        onClick={onReset}
        className="mt-5 inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white transition hover:bg-indigo-800"
      >
        <FaTimes />
        Réinitialiser les filtres
      </button>
    </div>
  );
}